import * as React from 'react';
import { Helmet } from 'react-helmet';

const INC_PUBLIC_KEY = '2435bb50613be2bf5ec53a0e2ab0fa62';
const BV_PUBLIC_KEY = '0f4319f5eadc146672e40079c89973cb';

const ProfitwellTag = ({ processor }: { processor?: string }) => {
  let pwKey;
  if (processor === 'stripe') {
    pwKey = INC_PUBLIC_KEY;
  } else if (processor === 'stripe_bv') {
    pwKey = BV_PUBLIC_KEY;
  } else {
    return null;
  }

  return (
    <Helmet>
      <script id="profitwell-js" data-pw-auth={pwKey}>
        {
          /* DO NOT DELETE - this code is used to accept our payments or send data to ProfitWell */
          `(function(i,s,o,g,r,a,m){i[o]=i[o]||function(){(i[o].q=i[o].q||[]).push(arguments)};
    a=s.createElement(g);m=s.getElementsByTagName(g)[0];a.async=1;a.src=r+'?auth='+
    s.getElementById(o+'-js').getAttribute('data-pw-auth');m.parentNode.insertBefore(a,m);
    })(window,document,'profitwell','script','https://public.profitwell.com/js/profitwell.js');

    profitwell('start', {});`
        }
      </script>
    </Helmet>
  );
};

export default ProfitwellTag;
